export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-ep-slider/index.js